import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const NotFoundPage = () => {
  const { user } = useAuth();
  
  // Determine where to redirect the user based on their role
  const homePath = user ? 
    (user.role === 'admin' || user.role === 'superadmin' ? '/admin/dashboard' : '/member/dashboard') 
    : '/';

  return (
    <div className="min-h-screen flex flex-col justify-center items-center text-center px-4 py-16">
      <h1 className="text-9xl font-extrabold text-gray-900">404</h1>
      <div className="h-2 w-24 bg-blue-600 my-4"></div>
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">Page Not Found</h2>
      <p className="text-lg text-gray-600 max-w-md mb-8">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to={homePath}
        className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 py-3 rounded-md inline-flex items-center"
      >
        <svg 
          className="w-5 h-5 mr-2" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth="2" 
            d="M10 19l-7-7m0 0l7-7m-7 7h18"
          />
        </svg>
        Back to Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
